export default "__VITE_ASSET__aIP9RS$a__"